export default function isFullCoordValid(coord: string) {
  const regex = /^((\-?|\+?)?\d+(\.\d+)?),\s((\-?|\+?)?\d+(\.\d+)?)$/;
  return regex.test(coord);
}
